/* eslint-disable no-case-declarations */
import {
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
  SET_USERS,
  INIT_DATA,
  SHOW_HELP_MODAL,
  RESET_USER_DATA
} from '../actions/types/index';

const INITIAL_STATE = {
  isAuthenticated: false,
  isInitializing: true,
  shopId: null,
  domainApi: '',
  businessType: '',
  printers: '',
  clients: [],
  address: {},
  legal: {},
  networkLegal: {},
  creditorNetwork: {},
  servicePrice: {},
  storageBucket: '',
  companyId: '',
  orderTypes: {},
  scheduleTimeWindow: 45,
  dashboardConfig: {},
  contactingButtons: [],
  oneTouchEnabled: false,
  generalAdmin: false,
  distributeurAdmin: false,
  nbShops: 1,
  isAllShops: false,
  initializedApp: {},
  dataHelpModalLink: null,
  configLegal: null,
  chainShopAdmin: false,
  independantShopAdmin: false,
  franchiseShopAdmin: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGN_IN_SUCCESS:
      const {
        domainApi,
        shopId,
        businessType,
        printers,
        address,
        networkLegal,
        servicePrice,
        legal,
        creditorNetwork,
        storageBucket,
        companyId,
        orderTypes,
        scheduleTimeWindow,
        dashboardConfig,
        contactingButtons,
        oneTouchEnabled,
        generalAdmin,
        distributeurAdmin,
        chainShopAdmin,
        independantShopAdmin,
        franchiseShopAdmin,
        userPermissions,
        nbShops,
        initializedApp,
        name,
        configLegal,
        isAllShops,
        paymentTypes
      } = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        shopId,
        domainApi,
        businessType,
        printers,
        address,
        legal,
        configLegal,
        networkLegal,
        creditorNetwork,
        servicePrice,
        storageBucket,
        companyId,
        orderTypes,
        scheduleTimeWindow,
        dashboardConfig,
        contactingButtons,
        oneTouchEnabled,
        generalAdmin,
        distributeurAdmin,
        chainShopAdmin,
        independantShopAdmin,
        franchiseShopAdmin,
        userPermissions,
        nbShops,
        initializedApp,
        shopName: name,
        isAllShops,
        paymentTypes
      };
    case INIT_DATA:
      return { ...state, isInitializing: action.payload };
    case SIGN_OUT_SUCCESS:
      return { ...state, isAuthenticated: false, shopId: null };
    case SET_USERS: {
      return { ...state, clients: action.payload };
    }
    case SHOW_HELP_MODAL: {
      return { ...state, dataHelpModalLink: action.payload };
    }
    case RESET_USER_DATA: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
